import React from "react";
import ruanfuwu from "./ruanfuwu.jpg";
class softServicesDetail extends React.Component {
  render() {
    return (
      <div style={{ minHeight: "100vh", background: "#f3f4f5" }}>
        <img src={ruanfuwu} style={{ width: "100%" }} />
      </div>
    );
  }
}

export default softServicesDetail;



// WEBPACK FOOTER //
// ./src/staticPage/softServices/index.js